import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Star } from 'lucide-react';

const AdCarousel = ({ providers, title }) => {
    const navigate = useNavigate();

    if (!providers || providers.length === 0) return null;

    return (
        <div className="ad-carousel-wrapper">
            {title && <h4 className="ad-carousel-title">{title}</h4>}
            <div className="provider-carousel">
                {providers.map(p => (
                    <div key={p.id} className="carousel-card" onClick={() => navigate('/marketplace')}>
                        <div className="c-img-box">
                            <img src={p.photo} alt={p.name} />
                            <div className="ad-badge">Ad</div>
                        </div>
                        <div className="c-info">
                            <h5 style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                                {p.name} {p.verified && <Star size={10} fill="var(--gold-verified)" color="var(--gold-verified)" title="Verified Provider" />}
                            </h5>
                            <span className="c-cat">{p.category}</span>
                            <span className="c-rate">₦{p.rate.toLocaleString()}</span>
                        </div>
                    </div>
                ))}
            </div>
            <style dangerouslySetInnerHTML={{
                __html: `
        .ad-carousel-wrapper { margin: 10px 0 20px; }
        .ad-carousel-title { font-size: 14px; color: var(--text-dark); margin-bottom: 8px; font-weight: 800; padding-left: 10px; }
        .provider-carousel { display: flex; gap: 12px; overflow-x: auto; padding: 0 0 8px; margin: 0 -10px; padding-left: 10px; padding-right: 10px; scrollbar-width: none; }
        .provider-carousel::-webkit-scrollbar { display: none; }
        .carousel-card { min-width: 140px; background: white; border-radius: 12px; border: 1px solid var(--border-gray); overflow: hidden; cursor: pointer; box-shadow: 0 4px 10px rgba(0,0,0,0.03); display: flex; flex-direction: column; transition: 0.2s; }
        .carousel-card:active { transform: scale(0.96); }
        .c-img-box { width: 100%; height: 90px; position: relative; }
        .c-img-box img { width: 100%; height: 100%; object-fit: cover; }
        .ad-badge { position: absolute; top: 8px; left: 8px; background: rgba(0,0,0,0.6); color: white; font-size: 9px; font-weight: 800; padding: 2px 6px; border-radius: 4px; text-transform: uppercase; letter-spacing: 0.5px; backdrop-filter: blur(4px); }
        .c-info { padding: 10px; display: flex; flex-direction: column; flex: 1; justify-content: space-between; gap: 4px; }
        .c-info h5 { font-size: 13px; margin: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: var(--text-dark); }
        .c-cat { font-size: 10px; color: var(--primary-green); font-weight: 700; text-transform: uppercase; }
        .c-rate { font-size: 12px; font-weight: 800; color: var(--text-dark); margin-top: 2px; }
            `}} />
        </div>
    );
};

export default AdCarousel;
